/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierStarterUnlimitedInstallStepsEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('TIER_STARTER_UNLIMITED_INSTALL_STEPS_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierStarterUnlimitedInstallStepsEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierStarterUnlimitedInstallStepsEnabledSettingParser.decode(input).map(res => new TierStarterUnlimitedInstallStepsEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierStarterUnlimitedInstallStepsEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierStarterUnlimitedInstallStepsEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierStarterUnlimitedInstallStepsEnabledSettingParser.schema();
    }
}
